<template>
    <div>
        <card-header title="Study Plans" icon="fa-clipboard-list-check"/>

        <card-body>
            <card-list>
                <subheader-list-item title="Pending Approval" icon="fa-clock" :badge="plans.length"/>

                <card-list-item
                    v-for="plan in plans"
                    :key="plan.id"
                    @click="$openCard('study-plan-detail', {enrollmentId: plan.id}, card)"
                    :class="{'active': child && child.definition.component === 'study-plan-detail' && child.props.enrollmentId == plan.id}"
                >
                    <template v-slot:icon><i class="far fa-clipboard-list-check fa-fw"></i></template>
                    <template v-slot:content>
                        <div class="meta">{{ plan.course_title }}</div>
                        <div class="tile-title">{{ plan.first_name }} {{ plan.last_name }}</div>
                        <div class="meta mt-1">
                            Submitted {{ plan.submitted_at | moment('MMMM Do, h:mm A') }}
                            <span v-if="plan.enrolled_hours">, {{ plan.enrolled_hours }} hours</span>
                        </div>
                    </template>
                </card-list-item>

                <div v-if="plans.length === 0" class="has-text-centered py-6 has-text-grey">
                    <i class="far fa-check-circle fa-3x mb-3"></i>
                    <p>No pending study plans</p>
                </div>
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import CardListItem from "@/TIER/components/CardListItem";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import {client as http} from "@/http_client";
    import {mapActions, mapGetters} from "vuex";

    export default {
        components: {SubheaderListItem, CardListItem, CardHeader, CardBody, CardList},
        props: ['card', 'child'],
        data() {
            return {
                plans: []
            };
        },
        computed: {
            ...mapGetters(['currentUser'])
        },
        methods: {
            ...mapActions(['getStudyPlansCount']),
            load: function() {
                http.get('/study-plans', {force: true}).then(response => {
                    this.plans = response.data;
                    this.$emit('loading', false);
                }).catch(err => {
                    console.error('Error loading study plans:', err);
                    this.$emit('loading', false);
                });
            },
            reload: function() {
                this.getStudyPlansCount();
                this.load();
            }
        },
        mounted: function() {
            this.load();
        }
    };
</script>

<style lang="scss" scoped>
    .tile-title {
        font-size: 0.9rem;
        font-weight: bold;
    }
</style>
